import { useIntl } from "react-intl";
export const Pagination = ()=>{
 const intl = useIntl();
      const pagination = {
        firstTooltip: intl.formatMessage({ id: 'component.mtable.firstTooltip' }),
        labelDisplayedRows: intl.formatMessage({ id: 'component.mtable.labelDisplayedRows' }),
        labelRowsPerPage: intl.formatMessage({ id: 'component.mtable.labelRowsPerPage' }),
        labelRowsSelect: intl.formatMessage({ id: 'component.mtable.labelRowsSelect' }),
        lastTooltip: intl.formatMessage({ id: 'component.mtable.lastTooltip' }),
        nextTooltip: intl.formatMessage({ id: 'component.mtable.nextTooltip' }),
        previousTooltip: intl.formatMessage({ id: 'component.mtable.previousTooltip' }),
        labelRows: intl.formatMessage({ id: 'component.mtable.labelRowsSelect' }),
      }
     const body = {
        editTooltip: intl.formatMessage({ id: 'component.mtable.editTooltip' }),
        emptyDataSourceMessage: intl.formatMessage({ id: 'component.mtable.emptyDataSourceMessage' }),
        editRow:{
          cancelTooltip:intl.formatMessage({ id: 'component.mtable.cancelTooltip'}),
          saveTooltip:intl.formatMessage({ id: 'component.mtable.save'})
        }
      }
     const grouping = {
        groupedBy: intl.formatMessage({ id: 'component.mtable.groupedBy' }),
        placeholder: intl.formatMessage({ id: 'component.mtable.placeholder' }),
      }
     const toolbar = {
        addRemoveColumns: intl.formatMessage({ id: 'component.mtable.addRemoveColumns' }),
        exportName: intl.formatMessage({ id: 'component.mtable.exportName' }),
        exportTitle: intl.formatMessage({ id: 'component.mtable.exportTitle' }),
        nRowsSelected: intl.formatMessage({ id: 'component.mtable.nRowsSelected' }),
        searchPlaceholder: intl.formatMessage({ id: 'component.mtable.searchPlaceholder' }),
        searchTooltip: intl.formatMessage({ id: 'component.mtable.searchTooltip' }),
        showColumnsTitle: intl.formatMessage({ id: 'component.mtable.showColumnsTitle' }),
      }
       const header= {
        actions:intl.formatMessage({ id: 'component.mtable.actions' })
       }
  return {pagination,body,toolbar,grouping,header}
  }



